import React from "react";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CommonButton from "./CommonButton/CommonButton";
import { BsInfoCircleFill } from "react-icons/bs";
import InfoIcon from "@mui/icons-material/Info";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "white",
  outline: "none",
  boxShadow: 24,
  borderRadius: "15px",
  p: 4,
};

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs:"70%",
    sm:"50%",
    lg: "60%"
  },
  bgcolor: "white",
  outline: "none",
  boxShadow: 24,
  borderRadius: "15px",
  // p: 4,
  p: 1,
}

const style1 = {
  position: "fixed",
  // top: "inherrit !important",
  // top: "50%",
  bottom: 0,
  left: "50%",
  // transform: "translate(-50%, -50%)",
  transform: "translateX(-50%)",
  width: "80%",
  bgcolor: "white",
  outline: "none",
  boxShadow: 24,
  borderRadius: "30px",
  borderBottomLeftRadius: "0px",
  borderBottomRightRadius: "0px",
  p: 4,
  "@media (min-width: 610px)":{
    width: "60%",
  },
  "@media (min-width: 1024px)":{
    width: "50%",
  },
};
const style3 = {
  width: "100% !important",
  // top:"inherit !important",
  bottom:"0px !important",
  maxHeight: "90vh",
  margin:"auto !inherit",
};
const iconColor ={
  color:"#e94d51 !important",
  fill:"#e94d51"
}

export const CommonTemplate = ({
  isTemplateOpen = true,
  closeTemplate,
  modalLabel,
  modalText,
  children
}) => {
  return (
    <div>
      <Modal
        open={isTemplateOpen}
        onClose={(event,reason)=>{
          console.log("reason",reason)
          if(reason!=="backdropClick"){
          closeTemplate()}}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableBackdropClick 
      >
        <Box sx={style2}>
          {children}
          {/* <div className="flex flex-row items-center gap-2">
            <BsInfoCircleFill /> <span className="lato-family">Notice</span>
          </div>
          <Typography
            id="modal-modal-title"
            sx={{ fontWeight: "bold", mt: 2 }}
            className="lato-family"
          >
            {modalLabel}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className="lato-family"
          >
            {modalText}
          </Typography>
          <div className="mt-4 m-auto ">
            <CommonButton
              center
              label="Close"
              filled
              onClickHandler={closeTemplate}
            />
          </div> */}
        </Box>
      </Modal>
    </div>
  );
};

export const CommonTemplate2 = ({
  isTemplateOpen = true,
  closeTemplate,
  modalLabel,
  modalText,
  children,
  okTemplate,
  submitTemplate,
  backTemplate,
  userDetails,
  kycType,
  btnText = "Okay, Understood",
  crossIcon = true,
  linkButton = false
}) => {
  return (
    <div>
    <>
    {!children ?
      <Modal
        open={isTemplateOpen}
        onClose={(event,reason)=>{
          console.log("reason",reason)
          if(reason!=="backdropClick"){
          closeTemplate()}}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableBackdropClick 
      >
        <Box sx={style}>
          <div className="flex flex-row items-center gap-2">
            {/* <BsInfoCircleFill /> <span className="lato-family">Notice</span> */}
            <BsInfoCircleFill  className="info_icon"  /> {
            !children ? (<span className="lato-family">Notice</span>)
            :
            <span className="lato-family  font-semibold ">{modalLabel}</span>
            }
          </div>
          <Typography
            id="modal-modal-title"
            sx={{ fontWeight: "bold", mt: 2 }}
            className="lato-family"
          >
            {/* {modalLabel} */}
            {!children ? (  {modalLabel}):""}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className="lato-family"
          >
            {modalText}
          </Typography>
          {children}
          <div className="flex text-center justify-between gap-10 md:w-[235px] md:m-auto pt-4 pb-2">
            <CommonButton
              center
              label="Proceed"
              filled
              onClickHandler={submitTemplate}
            />
          </div>
        </Box>
      </Modal>
    :<Modal
    open={isTemplateOpen}
    onClose={closeTemplate}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    sx={style3}
    >
    <Box sx={style1}>

      <div className="flex flex-row items-center gap-2">
      <BsInfoCircleFill className="info_icon" /> 
      {
      !children ? (<span className="lato-family">Notice</span>)
      :
        <span className="lato-family  font-semibold">{modalLabel}</span>
          }
            {crossIcon  && <button
          type="button"
          className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
           onClick={closeTemplate}
        >
            <svg
              aria-hidden="true"
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            
          </button>}
             </div> 
             
             <Typography
               id="modal-modal-title"
               sx={{ fontWeight: "bold", mt: 2 }}
               className="lato-family"
             >
             {
               !children ? (  {modalLabel}):""}
             </Typography>
             
             
             <Typography
               id="modal-modal-description"
               sx={{ mt: 2 }}
               className="lato-family"
             >
               {modalText}
             </Typography>
             {children}
             <div className="flex  text-center justify-between gap-10 md:w-[235px] md:m-auto pt-4 pb-2 ">
              { (userDetails || kycType == "Individual") ? 
              <CommonButton
              center
              label={btnText}
              filled
              onClickHandler={closeTemplate}
              
            /> :
              <>
             {/* <CommonButton
                 center
                 label="Change PAN"
                 filled
                 onClickHandler={backTemplate}
                 
               /> */}
              <CommonButton
                 center
                 label="Proceed"
                 filled
                 onClickHandler={submitTemplate}
                 
               />
               {/* <CommonButton
                 center
                 label="Close"
                 filled
                 onClickHandler={closeTemplate}
                 
               /> */}
               </>
              }
               
             </div>
           { linkButton &&   <div
                    className="text-center md:text-left underline text-blue cursor-pointer md:mt-1.5 mb-3 md:mb-0"
                    style={{ color: "blue" }}>
                    <p
                      onClick={closeTemplate}
                      id="otherDocsKyc"
                    >
                      Aadhaar using UIDAI
                    </p>
              </div>}
             
           </Box>
    </Modal>
    }
    </>
    </div>
  );
};


export const CommonTemplate3 = ({
  isTemplateOpen = true,
  closeTemplate,
  okTemplate,
  modalLabel,
  modalText,
  submitTemplate,
  backTemplate,
  children,
  userDetails,
  kycType,
  btnText = "Okay, Understood",
  crossIcon = true,
  linkButton = false,
  otpValueLength
}) => {
  return (
    <div>
      <>
      {!children ?
      <Modal
        open={isTemplateOpen}
        onClose={closeTemplate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <div className="flex flex-row items-center gap-2">
            <BsInfoCircleFill  className="info_icon"  /> {
            !children ? (<span className="lato-family">Notice</span>)
            :
          <span className="lato-family  font-semibold ">{modalLabel}</span>
            }
           
          </div>
          <Typography
            id="modal-modal-title"
            sx={{ fontWeight: "bold", mt: 2 }}
            className="lato-family"
          >
            {modalLabel}
            {
            !children ? (  {modalLabel}):""}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className="lato-family"
          >
            {modalText}
          </Typography>
          {children}
          <div className="flex  text-center justify-between gap-10 md:w-[235px] md:m-auto pt-4 pb-2">
          {/* <CommonButton
              center
              label="Change PAN"
              filled
              onClickHandler={backTemplate}
             
            /> */}
          <CommonButton
              center
              label="Proceed"
              filled
              onClickHandler={submitTemplate}
             
            />
            {/* <CommonButton
              center
              label="Close"
              filled
              onClickHandler={closeTemplate}
            /> */}
          </div>
        </Box>
      </Modal>
      :<Modal
      open={isTemplateOpen}
      // onClose={closeTemplate} // user click outside of popup then it will be closed.
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={style3}
      >
      <Box sx={style1}>
                 
                 <div className="flex flex-row items-center gap-2">
                 <InfoIcon sx={{ color: "red", fontSize: "20px" }} />
                 {
                 !children ? (<span className="lato-family">Notice</span>)
                 :
               <span className="lato-family  font-semibold">{modalLabel}</span>
                 }
                {crossIcon  && <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
               onClick={closeTemplate}
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
             
            </button>}
               </div>
               
               <Typography
                 id="modal-modal-title"
                 sx={{ fontWeight: "bold", mt: 2 }}
                 className="lato-family"
               >
               {
                 !children ? (  {modalLabel}):""}
               </Typography>
               
               
               <Typography
                 id="modal-modal-description"
                 sx={{ mt: 2 }}
                 className="lato-family"
               >
                 {modalText}
               </Typography>
               {children}
               <div className="flex  text-center justify-between gap-10 md:w-[235px] md:m-auto pt-4 pb-2 ">
                { (userDetails || kycType == "Individual") ?
                <CommonButton
                center
                label={btnText}
                filled
                onClickHandler={closeTemplate}
               
              /> :
                <>
               {/* <CommonButton
                   center
                   label="Change PAN"
                   filled
                   onClickHandler={backTemplate}
                   
                 /> */}
                <CommonButton
                   center
                   label="Proceed"
                   filled
                   onClickHandler={submitTemplate}
                   disabled = {otpValueLength === 6 ? false : true}
                 />
                 {/* <CommonButton
                   center
                   label="Close"
                   filled
                   onClickHandler={closeTemplate}
                   
                 /> */}
                 </>
                }
                 
               </div>
             { linkButton &&   <div
                      className="text-center underline text-blue cursor-pointer md:mt-1.5 mb-3 md:mb-0"
                      style={{ color: "blue" }}>
                      <p
                        onClick={closeTemplate}
                        id="otherDocsKyc"
                      >
                        For Aadhaar Journey, Click here.
                      </p>
                </div>}
               
             </Box>
           </Modal>
      }
            </>
    </div>
  );
};


export const CommonTemplate4 = ({
  isTemplateOpen = true,
  closeTemplate,
  okTemplate,
  modalLabel,
  modalText,
  submitTemplate,
  backTemplate,
  children,
  userDetails,
  kycType,
  btnText = "Okay, Understood",
  crossIcon = true,
  linkButton = false,
  otpValueLength
}) => {
  return (
    <div>
      <>
      {!children ? 
      <Modal
        open={isTemplateOpen}
        onClose={closeTemplate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <div className="flex flex-row items-center gap-2">
            <BsInfoCircleFill  className="info_icon"  /> {
            !children ? (<span className="lato-family">Notice</span>)
            :
          <span className="lato-family  font-semibold ">{modalLabel}</span>
            }
            
          </div> 
          <Typography
            id="modal-modal-title"
            sx={{ fontWeight: "bold", mt: 2 }}
            className="lato-family"
          >
            {modalLabel}
            {
            !children ? (  {modalLabel}):""}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className="lato-family"
          >
            {modalText}
          </Typography>
          {children}
          <div className="flex  text-center justify-between gap-10 md:w-[235px] md:m-auto pt-4 pb-2">
          {/* <CommonButton
              center
              label="Change PAN"
              filled
              onClickHandler={backTemplate}
              
            /> */}
          <CommonButton
              center
              label="Proceed"
              filled
              onClickHandler={submitTemplate}
              
            />
            {/* <CommonButton
              center
              label="Close"
              filled
              onClickHandler={closeTemplate}
            /> */}
          </div>
        </Box>
      </Modal>
      :<Modal
      open={isTemplateOpen}
      // onClose={closeTemplate}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={style3}
      >
      <Box sx={style1}>
                 
                 <div className="flex flex-row items-center gap-2">
                 {/* <BsInfoCircleFill className="info_icon" />  */}
                 <InfoIcon sx={{ color: "red", fontSize: "20px" }} />
                 {
                 !children ? (<span className="lato-family">Notice</span>)
                 :
               <span className="lato-family  font-semibold">{modalLabel}</span>
                 }
                {crossIcon  && <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
               onClick={closeTemplate}
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              
            </button>}
               </div> 
               
               <Typography
                 id="modal-modal-title"
                 sx={{ fontWeight: "bold", mt: 2 }}
                 className="lato-family"
               >
               {
                 !children ? (  {modalLabel}):""}
               </Typography>
               
               
               <Typography
                 id="modal-modal-description"
                 sx={{ mt: 2 }}
                 className="lato-family"
               >
                 {modalText}
               </Typography>
               {children}
               <div className="flex  text-center justify-between gap-10 md:w-[235px] md:m-auto pt-4 pb-2 ">
                {/* { (userDetails || kycType == "Individual" ) ? 
                <CommonButton
                center
                label={btnText}
                filled
                onClickHandler={closeTemplate}
                /> : 
                <>
                <CommonButton
                   center
                   label="Proceed2222"
                   filled
                   onClickHandler={submitTemplate}
                   disabled = {otpValueLength === 6 ? false : true}
                   
                 />
                 </>
                } */}
                { (userDetails || kycType == "Individual" ) ? 
                <CommonButton
                center
                label={btnText}
                filled
                onClickHandler={closeTemplate}
                /> : 
                kycType == "Cersai"  ? 
                <>
                <CommonButton
                   center
                   label="Proceed"
                   filled
                   onClickHandler={submitTemplate}
                   disabled = {otpValueLength === 6 ? false : true}
                 />
                 </>
                :
                <>
                <CommonButton
                   center
                   label="Proceed"
                   filled
                   onClickHandler={submitTemplate}
                 />
                 </>
                }
                 
               </div>
             { linkButton &&   <div
                      className="text-center underline text-blue cursor-pointer md:mt-1.5 mb-3 md:mb-0"
                      style={{ color: "blue" }}>
                      <p
                        onClick={closeTemplate}
                        id="otherDocsKyc"
                      >
                        {/* Aadhaar using UIDAI */}
                        For Aadhaar Journey, Click here.
                      </p>
                </div>}
               
             </Box>
           </Modal>
      }
            </>
    </div>
  );
};


// export default CommonTemplate;
